import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import SearchCaseContact from './SearchCaseContact';
import { store } from '../../store/store';
import { Provider } from 'react-redux';

loadDOMComponent({
	selector: 'react-search-case-contact',
	callback: ({ container }: any) => {
		const linkSelect = container.getAttribute('linkSelect') || null;
		const patientId = container.getAttribute('patientId') || null;

		// selectLink
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<SearchCaseContact linkSelect={linkSelect} patientId={patientId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
